// extracted by mini-css-extract-plugin
export default {"contant":"ImageItemMoby_contant__5GTyu","moby":"ImageItemMoby_moby__qohBb"};